import {
  GET_NOTIFICATION_COUNT_REQUEST,
  GET_NOTIFICATION_COUNT_SUCCESS,
  GET_NOTIFICATION_COUNT_FAILED,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILED,
} from '../types';

const IntialState = {
  loading: false,
  status: null,
  message: null,
  count: 0,
  list: [],
  isError: false,
};

const notifications = (state = IntialState, action) => {
  const { type, response: res, message } = action;
  switch (type) {
    case GET_NOTIFICATION_COUNT_REQUEST:
    case GET_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        status: res?.status,
        count: res?.count,
        loading: false,
        isError: false,
      };

    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        status: res?.status,
        list: res?.data,
        loading: false,
        isError: false,
      };
    case GET_NOTIFICATION_COUNT_FAILED:
    case GET_NOTIFICATIONS_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

export default notifications;
